import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnInit,
} from '@angular/core';
import { MenuItemsLayout, OrderableIngredient, PanelItem, SizePrice, Upsell, UpsellType } from 'ngx-web-api';

import { MenuWrapperService } from '../../../core/services/menu-wrapper.service';
import { OrderingUtilsService } from 'app/core/services/ordering-utils.service';

@Component({
  selector: 'fts-sister-upsell',
  templateUrl: './sister-upsell.component.html',
  styleUrls: ['./sister-upsell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SisterUpsellComponent implements OnInit, OnChanges {
  @Input()
  upsell: Upsell;
  @Output()
  itemAddedToOrder: EventEmitter<string> = new EventEmitter();

  menuItemsLayoutEnum = MenuItemsLayout;
  selectedQuantity = 1;
  selectedSizePrice: SizePrice;
  panelItem: PanelItem;
  imageUrl: string;
  calories?: string;
  upsellType = UpsellType.ITEM_BASED;
  selectedUpfrontIngredient: OrderableIngredient;
  upfrontQualifiers: string[] = [];

  constructor(
    private menuService: MenuWrapperService,
    private cdRef: ChangeDetectorRef,
    private orderingUtilsService: OrderingUtilsService
  ) {}

  ngOnInit() {
    this.orderingUtilsService.itemAddedToOrder$.subscribe(result => this.itemAddedToOrder.emit(result));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['upsell']) {
      this.panelItem = this.menuService.convertUpsellToPanelItem(this.upsell);
      this.selectedSizePrice = this.menuService.getDefaultSizePrice(this.panelItem.sizePrices);
      this.imageUrl = this.menuService.getPanelItemPictureSrc(this.panelItem);
      this.calories = this.menuService.getItemCalories(this.selectedSizePrice, this.panelItem.showFullSizeCalories);
    }
  }

  onSizeChange(size: SizePrice): void {
    this.calories = this.menuService.getItemCalories(size, this.panelItem.showFullSizeCalories);
  }

  onPictureSet() {
    this.cdRef.detectChanges();
  }

  onIngredientChange(ingredient: OrderableIngredient) {
    this.selectedUpfrontIngredient = ingredient;
  }

  onQualifierChange(qualifer: string[]) {
    this.upfrontQualifiers = qualifer;
  }
}
